import React, { useEffect, useState } from 'react';

import { userActions } from '../../actions';
import { history } from '../../helpers';

import * as moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import DatePicker from "react-datepicker";
import fr from 'date-fns/locale/fr';

const DateCustomInput = ({ value, onClick }) => (
  <button className="example-custom-input" onClick={onClick}>
    <svg className="icon" aria-hidden="true">
      <use xlinkHref="#icon-23-calendar-alt" />
    </svg>
    <strong>{moment(value).format('dddd DD MMMM')}&nbsp;</strong>
  </button>
);

function AddReservation() {
  const dispatch = useDispatch();

  const [currentDate, setCurrentDate] = useState(null);

  const planningState = useSelector(state => state.planning);
  const globalState = useSelector(state => state.global);

  const isWeekday = date => {
    const day = moment(date).day();
    return day !== 0;
  };

  useEffect(() => {

    dispatch(userActions.loadPlanning(currentDate ? currentDate.format('DD-MM-YYYY') : null));
  }, [dispatch, currentDate]);

  return (
    <div className="bloc-reservation">
      <h2 className="bloc-reservation__title">
        <span className="bloc-reservation__icon">
          <svg className="icon" aria-hidden="true">
            <use xlinkHref="#icon-15-raquette" />
          </svg>
        </span>
          Ajouter une réservation
      </h2>
      {planningState && globalState.courts &&
        <div>
          <div className="bloc-reservation__item no-hover">
            <button disabled={!planningState.prevDate}
              className="btn--filter" onClick={() => setCurrentDate(moment.unix(planningState.prevDate))}>&lt;</button>
            <div className="text-center">
              {planningState.date &&
                <div>
                  <DatePicker
                    minDate={new Date()}
                    locale={fr}
                    dateFormat="yyyy-MM-dd"
                    maxDate={moment().add(planningState.dayLimit, 'days').toDate()}
                    filterDate={isWeekday}
                    selected={moment.unix(planningState.date).toDate()}
                    onChange={date => setCurrentDate(moment(date))}
                    customInput={<DateCustomInput />}
                    popperPlacement="top-center"
                  />
                </div>
              }
              <span className="bloc-reservation__people"><i>Sélectionnez un créneau libre pour réserver</i></span>
            </div>
            <button disabled={!planningState.nextDate}
              className="btn--filter" onClick={() => setCurrentDate(moment.unix(planningState.nextDate))}>&gt;</button>
          </div>
          <table className="table-reservation">
            <thead>
              <tr>
                <th></th>
                {globalState.courts.map((court) =>
                  <th key={court.id}><span>{court.nom}</span></th>
                )}
              </tr>
            </thead>
            <tbody>
              {planningState.step &&
                <ReservationCurrentTime timeItem={globalState.config.creneau} step={planningState.step}></ReservationCurrentTime>
              }
              {planningState.step && planningState.step.map((step, x) =>
                <tr className={step.full ? 'full' : ''} key={step.timestamp}>
                  <td className="col-time"><span>{moment.unix(step.timestamp).format('LT')}</span></td>
                  {globalState.courts.map((court, y) =>
                    <ReservationItem key={court.id} court={court} timestamp={step.timestamp}></ReservationItem>
                  )}
                </tr>
              )}
            </tbody>
          </table>
        </div>
      }
    </div>
  );
}

function ReservationCurrentTime(props) {
  const globalState = useSelector(state => state.global);

  const first = props.step[0].timestamp;
  const last = props.step[props.step.length - 1].timestamp + (globalState.config.creneau * 60);
  const current = moment().unix();

  if (current < first || current > last) {
    return null;
  }

  const percent = ((current - first) / (last - first));
  const theadDelta = (1 - percent) * 15; // 15 = thead height

  const currentTimeStyle = {
    display: 'table-row',
    top: `calc(${percent * 100}% + ${theadDelta}px)`
  };

  return (
    <tr className="current-time" style={currentTimeStyle}></tr>
  )
}

function ReservationItem(props) {
  const globalState = useSelector(state => state.global);

  const dispatch = useDispatch();

  const planningState = useSelector(state => state.planning);

  const res = planningState.items.find(row =>
    row.court.id === props.court.id &&
    (row.debut <= props.timestamp && row.fin >= props.timestamp + 1)
  );

  const handleClickResa = (court, debut) => {
    dispatch(userActions.addReservation({ court, debut, fin: debut + (globalState.config.creneau * 60) }));

    history.push('/reservation/nouveau');
  };

  if (res && res.debut === props.timestamp) {
    const reservationStyle = {
      height: (30 * res.nbCreneau) - 1
    };

    const text = res.clients ? res.people : (res.evenement ? res.commentaire : 'réservé');

    return (
      <td className="col-resa col-resa-first">
        <div className="item-backdrop" style={reservationStyle}>
          <div className={`item-resa ${res.clients ? 'item-resa--you' : ''}`}>
            <span>{text}</span>
          </div>
        </div>
      </td>
    );
  }

  if (res) {
    return (
      <td className="col-resa"></td>
    )
  }

  if (moment.unix(props.timestamp).isBefore()) {
    return (
      <td className="col-empty"></td>
    )
  }

  return (
    <td className="col-empty">
      <div onClick={() => handleClickResa(props.court.id, props.timestamp)}>réserver à {moment.unix(props.timestamp).format('LT')}</div>
    </td>
  )
}

export default AddReservation;
